module.exports = __webpack_public_path__ + "static/media/project3.45c25007.png";